export const skills = [
    "Python",
    "Javascript",
    "React",
    "Node",
    "Express",
    "Flask",
    "Django",
    "C",
    "C++",
    "Java",
    "PHP",
    "HTML",
    "CSS",
    "SQL",
    "Git",
    "Linux/Bash Scripting",
    "Powershell Scripting",
    "Mobile App Development",
    "Web Development",
    "Artificial Intelligence Algorithms",
    "Data Structures",
    "Structural Decompositions",
    "Behavioral Decompositions",
    "Software Testing",
    "Quality Analysis",
    "Solidworks 2019",
    "CAD",
    "Microsoft Office Suite",
    "Android Studio",
    "TensorFlow"
];

